// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<section id="customer-loans-edit-credit-losses-allowance" class="box">
  <sub-header header="'Edit Allowance for Credit Losses'"></sub-header>

  <div class="content">
    <form name="\$ctrl.form">
      <form-section>
        <table class="table table--generate-row-ids">
          <thead>
            <th>No.</th>
            <th></th>
            <th>Current State</th>
            <th>Adjustment</th>
            <th>Target State</th>
          </thead>
          <tbody class="tbody">
            <tr>
              <td></td>
              <td>
                Loan Status
                <help title="Can be edited in Edit Metadata only"></help>
              </td>
              <td><input ng-disabled="true" type="text" ng-model="\$ctrl.status"/></td>
              <td></td>
              <td></td>
            </tr>

            <tr>
              <td></td>
              <td>Principal Balance</td>
              <td><cash ng-disabled="true" ng-model="\$ctrl.principalBalance" ignore-amount-validation="true"></cash></td>
              <td></td>
              <td></td>
            </tr>

            <tr>
              <td></td>
              <td>
                Provision Rate
                <help title="Can be edited in Edit Metadata only"></help>
              </td>
              <td><input ng-disabled="true" type="text" ng-model="\$ctrl.provisionRate"/></td>
              <td></td>
              <td></td>
            </tr>

            <tr>
              <td></td>
              <td>Allowance for credit losses</td>
              <td><cash ng-disabled="true" ng-model="\$ctrl.currentCreditLossesAllowance" ignore-amount-validation="true"></cash></td>
              <td><cash ng-disabled="true" value="\$ctrl.adjustment('creditLossesAllowance')"></cash></td>
              <td><cash min="0" ng-model="\$ctrl.targetCreditLossesAllowance"></cash></td>
            </tr>

            <tr>
              <td></td>
              <td>Remarks</td>
              <td>
                <input class="remarks" type="text" ng-model="\$ctrl.remarks"/>
              </td>
              <td colspan="2"></td>
            </tr>
          </tbody>
        </table>
        <div>
        </div>
        <div class="buttons">
          <button class="btn btn-warning" ng-click="\$ctrl.goBack()">Cancel</button>
          <button class="btn btn-success" ng-click="\$ctrl.save()" ng-disabled="\$ctrl.form.\$pristine || \$ctrl.form.\$invalid">Save</button>
        </div>
      </form-section>
    </form>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/edit/customer-loans-edit-credit-losses-allowance.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;